<template>
  <v-app>
    <v-navigation-drawer
      :clipped="clipped"
      v-model="sideNav"
      temporary
      app
      >
      <v-list>
        <v-list-tile
          v-for="(item,idx) in visibleMenuItems"
          :key="idx"
          @click="onMenuItemClick(item)"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            {{ $t(item.title) }}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="clipped" app>
      <v-toolbar-side-icon
       class="hidden-sm-and-up"
       @click.stop="sideNav = !sideNav"></v-toolbar-side-icon>
      <v-toolbar-title>
        <router-link to="/" tag="span" style="cursor: pointer">
          <img src="@/assets/transpress-logo.png" :alt="$t('app_title')" style="max-height: 30px; max-width: 100%; margin: 4px 0 -4px" />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat v-for="(item,idx) in visibleMenuItems" :key="idx" @click="onMenuItemClick(item)"
          class="pa-0 main-nav-item text-sm-center" style="min-width: 3rem" color="primary"
        >
          <v-spacer class="mx-2 hidden-xl-only hidden-sm-and-down"></v-spacer>
          <v-layout row wrap>
            <v-flex xs12>
              <v-icon slot="activator" class="hidden-lg-and-down">{{ item.icon }}</v-icon>
              <v-tooltip bottom class="hidden-xl-only">
                <v-icon slot="activator">{{ item.icon }}</v-icon>
                <span>{{ $t(item.title) }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs12>
              <span class="hidden-lg-and-down caption">{{ $t(item.title) }}</span>
            </v-flex>
          </v-layout>
          <v-spacer class="mx-2 hidden-xl-only hidden-sm-and-down"></v-spacer>
        </v-btn>
      </v-toolbar-items>
      <v-divider vertical inset class="hidden-xs-only"></v-divider>
      <v-tooltip bottom v-if="news.showInToolbar">
        <v-btn icon small @click="news.modal = !news.modal" slot="activator">
          <v-icon color="red">info</v-icon>
        </v-btn>
        <span class="caption">{{ $t('Important') }}</span>
      </v-tooltip>
      <credit-limit v-model="clientDebt"></credit-limit>
      <v-badge :color="notifications.unread > 0 ? 'red' : 'grey lighten-1'" overlap :class="{'mx-1': $vuetify.breakpoint.smAndUp}">
        <template v-slot:badge>
          <span class="caption">{{ notifications.unreadInitial }}</span>
        </template>
        <v-btn icon small @click="notifications.show = !notifications.show">
          <v-icon color="primary" v-if="notifications.unread > 0" class="bell-shake">notifications_active</v-icon><!-- notification_important -->
          <v-icon color="primary" v-else>notifications</v-icon>
        </v-btn>
      </v-badge>
      <v-menu offset-y origin="top right" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon slot="activator">
          <v-icon color="primary">account_circle</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-subheader v-if="profile.user" class="body-1 font-weight-light blue--text text--darken-2">
            <v-icon left class="blue--text text--darken-2">person</v-icon>{{ profile.user }}<br />
          </v-subheader>
          <v-divider   v-if="profile.user"></v-divider>
          <v-list-tile v-for="(item,index) in profileItems" :key="index"
            :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" :target="item.target"
            :disabled="item.disabled" rel="noopener"
            ripple="ripple"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <div class="body-1 font-weight-light grey--text pa-2">
            {{ versionInfo }}
          </div>
        </v-list>
      </v-menu>
    </v-toolbar>

    <modal-news  v-model="news.modal"></modal-news>
    <modal-wms   v-model="wms.modal"></modal-wms>

    <settings    v-model="settings.modal"></settings>

    <notifications v-model="notifications.show" @unreadCount="notifications.unread = $event" @itemsCount="notifications.items = $event"></notifications>

    <chat-module v-model="chat" :profile="profile"></chat-module>

    <v-content app>
      <v-fade-transition>
        <router-view :poke="poke" @poked="poked"></router-view>
      </v-fade-transition>
    </v-content>

    <!-- User profile dialog -->
    <v-dialog v-model="profile.show" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('User Profile') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="profileForm">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select v-if="isMultiOrg" :label="$t('Client')" v-model="profile.current" :items="profile.holding" item-value="code" item-text="name" return-object @change="companyChanged"></v-select>
                <v-text-field v-else :label="$t('Client')" v-model="profile.name" disabled></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('Username')" v-model="profile.user" readonly disabled></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('Client Contact Person')" v-model="profile.person"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('Client Contact Phone')" v-model="profile.phone" type="tel" :hint="$t('Phone BG hint')" :rules="vPhone"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('Client Contact Email')" v-model="profile.email" :rules="vEmail"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="onClose">{{ $t('Close') }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="onSave" :loading="profileSaving">
            <v-icon>save</v-icon>&nbsp;{{ $t('Save' ) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- User profile Change Pass dialog -->
    <v-dialog v-model="profilePass.show" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline px-3">{{ $t('Change Password') }} {{ $t('for user') }} {{ profile.user }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="passwordForm">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field :label="$t('Current password')" v-model="profilePass.password"
                  :append-icon="profilePass.pass1Visible ? 'visibility' : 'visibility_off'"
                  :type="profilePass.pass1Visible ? 'text' : 'password'" counter
                  @click:append="profilePass.pass1Visible = !profilePass.pass1Visible"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('New password')" v-model="profilePass.passwordNew"
                  :append-icon="profilePass.pass2Visible ? 'visibility' : 'visibility_off'"
                  :type="profilePass.pass2Visible ? 'text' : 'password'" counter
                  @click:append="profilePass.pass2Visible = !profilePass.pass2Visible"
                  loading :hint="$t('Password strength') + ': ' + profilePassProgress + '%'">
                  <template v-slot:progress>
                    <v-progress-linear :value="profilePassProgress" :color="profilePassColor" height="5"></v-progress-linear>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field :label="$t('Re-enter new password')" v-model="profilePass.passwordNew2"
                  :append-icon="profilePass.pass3Visible ? 'visibility' : 'visibility_off'"
                  :type="profilePass.pass3Visible ? 'text' : 'password'" counter
                  @click:append="profilePass.pass3Visible = !profilePass.pass3Visible"
                  loading>
                  <template v-slot:progress>
                    <v-progress-linear :value="profilePassProgress * profilePassCheck" :color="profilePassColor" height="5"></v-progress-linear>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="profilePass.show = false">{{ $t('Close') }}</v-btn>
          <v-btn color="blue darken-1" flat @click.native="onSavePass" :loading="profileSaving" :disabled="!profilePassCheck">
            <v-icon>verified_user</v-icon>&nbsp;{{ $t('Save' ) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="errorBar" value="true" right top multi-line color="error" :timeout="5000">
      {{ errorMsg }}
      <v-btn dark flat @click="errorBar = false">
        {{ $t('OK')}}
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { user } from "../resources";
import Notifications from "./Notifications.vue";
import ChatModule from "./Chat.vue";
import ModalNews from "./News.vue";
import ModalWms from "../components/ModalWms.vue";
import CreditLimit from "../components/CreditLimit.vue";
import Settings from "./Settings.vue";
import { validateEmail, extractBodyErrorMessages, versionInfo } from "../components/util";

import { phoneRules } from "../components/phone";

export default {
  components: {
    ModalNews,
    Notifications,
    ChatModule,
    CreditLimit,
    ModalWms,
    Settings
  },
  name: "App",
  data() {
    return {
      errorBar: false,
      errorMsg: "",
      profileSaving: false,
      sideNav: false,
      clipped: true,
      menuVer: 1,
      profile: {
        show: false,
        user: "", // username
        name: "", // title
        person: "",
        phone: "",
        email: ""
      },
      profilePass: {
        show: false,
        password: "",
        pass1Visible: false,
        passwordNew: "",
        pass2Visible: false,
        passwordNew2: "",
        pass3Visible: false
      },
      holdingLen: 1,
      news:  { modal: false, showInToolbar: false },
      wms:   { modal: false, enabled: false },
      settings: { modal: false },
      notifications: { show: false, items: 0, unread: 0, unreadInitial: 0 },
      chat: false,// disable chat-module
      poke: false,
      menuItems: [
        { icon: "home",            title: "main screen",         link: "/dashboard"  },
        { icon: "search",          title: "tracking screen",     link: "/track"      },
        { icon: "create",          title: "request screen",      link: "/request/0", poke: true                       },
        { icon: "card_giftcard",   title: "my shipments screen", link: "/shipments"  },
        { icon: "import_export",   title: "imports screen",      link: "/imports"    },
        { icon: "import_contacts", title: "my contacts screen",  link: "/contacts"   },
        { icon: "attach_money",    title: "cod screen",          link: "/cod",       rule: "/report/cash-on-delivery" },
        { icon: "list_alt",        title: "invoice screen",      link: "/invoices",  rule: "/invoice"                 },
        { icon: "cases",           title: "Claims",               link: "/cases"      },
        { icon: "emoji_objects",   title: "Consumables",         link: "/consumables",                                },// camera_roll, emoji_objects
        { icon: "warehouse",       title: "warehouse",           link: "/wms",       id: "wms"                        },
        { icon: "email",           title: "contact screen",      link: "/contact-us" }
      ],
      profileItems: [
        {
          icon: "account_circle",
          href: "#",
          title: "Profile",
          click: (e) => {
            if (!this.profile.name)
              this.onLoad();
            this.profile.show = true;
          }
        },
        {
          icon: "settings",
          href: "#",
          title: "Settings",
          click: (e) => {
            this.settings.modal = true;
          }
        },
        {
          icon: "lock",
          href: "#",
          title: "Change Password",
          click: (e) => {
            if (!this.profile.name)
              this.onLoad();
            this.profilePass.show = true;
          }
        },
        {
          icon: "fullscreen_exit",
          href: "#",
          title: "Logout",
          click: (e) => {
            this.$store.dispatch("logout");
            this.$store.dispatch("setUserConfigPrincipal", "");
            let resource = this.$resource(process.env.VUE_APP_API_PATH + "/logoff.do");

            resource.get().then(response => {
              this.$store.state.auth = false;
              this.$router.push({ name : "signin" }).catch(e => {});
            }, response => {
              console.log("Error logging out");
              this.$store.state.auth = false;
              this.errorMsg = this.$t("Error logging out");
              this.errorBar = true;
            }).catch(error=> {
              console.log("Exception caught on logout", error);
            });
          }
        }
      ],
      clientDebt: null,
      vEmail : [(v) => !v || validateEmail(v) || this.$t("Invalid email address")],
      vPhone : phoneRules(key => this.$t(key), { country: "BG" }),
    }
  },

  computed: {
    ...mapGetters(["userInfo", "currentCompany"]),
    versionInfo() {
      return versionInfo(this, false);
    },
    isIe() {
      return (Object.hasOwnProperty.call(window, "ActiveXObject") && !window.ActiveXObject);
    },
    visibleMenuItems() {
      return this.menuVer > 0 ? this.menuItems.filter((e) => typeof e.show === "undefined" || e.show) : [];
    },
    isMultiOrg() {
      return this.holdingLen > 1;
    },
    profilePassCheck() {
      let pass     = this.profilePass.password,
          passnew  = this.profilePass.passwordNew,
          passnew2 = this.profilePass.passwordNew2;
      if (pass.length == 0 || passnew.length == 0 || passnew2.length == 0)
        return false;
      // new passwords must match
      if (passnew !== passnew2)
        return false;
      // new pass same as the old pass?
      if (passnew === pass)
        return false;
      return true;
    },
    profilePassProgress() {
      let pass = this.profilePass.passwordNew;
      let score = 0;
      if (!pass)
        return score;

      // award every unique letter until 5 repetitions
      let letters = new Object();
      for (var i=0; i<pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
      }

      // bonus points for mixing it up
      let variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
      }

      let variationCount = 0;
      for (var check in variations) {
        variationCount += (variations[check] == true) ? 1 : 0;
      }
      score += (variationCount - 1) * 10;

      return Math.min(100, parseInt(score));
    },
    profilePassColor() {
      return ['error', 'warning', 'success'][Math.floor(this.profilePassProgress / 40)];
    },
  },

  created() {
    let store = this.$store;
    if (!!store.state.user.user) {
      store.dispatch("setUserConfigPrincipal", store.state.user.user);
    }
    else {
      store.dispatch("loadUserInfo").then((i) => {
        store.dispatch("setUserConfigPrincipal", i.user);
      });
    }
  },

  mounted() {
    if (this.currentCompany && this.currentCompany.code)
    {
      this.profile.current = this.currentCompany;
      this.profile.currentSet = true;
    } else {
      delete this.profile.currentSet;
    }

    this.onLoad();
  },

  methods : {
    ...mapActions(["loadUserInfo", "updateCompany"]),

    companyChanged() {
      this.updateCompany(this.profile.current);
    },

    onLoad() {
      this.loadUserInfo().then((ui) => {
        if (ui && typeof ui !== "undefined") {
          this.profile.name = ui.name;
          this.profile.user = ui.user;
          this.profile.email = ui.email;
          this.profile.phone = ui.phone;
          this.profile.person = ui.person;

          if (ui.holding && ui.holding.length > 0)
          {
            this.profile.holding = ui.holding.slice();
            let e = ui.holding.find(e => e.code === ui.code);
            if (!e)
            {
              this.profile.holding.unshift({code: ui.code, name: ui.name});
            }
            this.holdingLen = this.profile.holding.length;
          }
          if (!this.profile.currentSet)
          {
            this.profile.currentSet = true;
            this.profile.current = {
              code: ui.code,
              name: ui.name
            };
          }
          if (ui.access && ui.access.length > 0)
          {
            for (let idx = 0; idx<ui.access.length; idx++ )
            {
              let rule = ui.access[idx];
              let mi = this.menuItems.find( (e) => e.rule && e.rule === rule.path);
              if (!!mi) {
                mi.show = rule.mode;
                this.menuVer ++;
                if (!rule.mode)
                  console.log("Removed menu item " + mi.link + " due to access rule " + rule.path);
              }
            }
          }
          if (ui.clientDebt && ui.clientDebt.creditLimit) {
            this.clientDebt = ui.clientDebt;
          }
          this.wms.enabled = ui.wmsEnabled;

        } else {
          this.holdingLen = 0;
        }
      }).catch((err) => {
        console.log("Error loading user info", err);
        this.holdingLen = 0;
        this.$store.dispatch("setUserConfigPrincipal", "");
      });
    },

    onClose() {
      this.profile.show = false;
    },

    onSave() {
      if (!this.$refs.profileForm.validate()) {
        this.errorMsg = this.$t('Please fix errors before continuing!')
        this.errorBar = true;
        return;
      }

      this.profileSaving = true;
      user.save({}, this.profile).then((r) => {
        this.onClose();
      }, (e) => {
        let msg = extractBodyErrorMessages(e.body);
        if (!!msg)
          this.errorMsg = msg;
        else
          this.errorMsg = this.$t('Error saving profile');
        this.errorBar = true;
      }).catch((err) => {
        this.errorMsg = this.$t('Unexpected error saving profile');
        this.errorBar = true;
        console.log(err);
      }).finally(() => {
        this.profileSaving = false;
      });
    },
    onSavePass() {
      if (!this.profilePassCheck) {
        this.errorMsg = this.$t('Please fix errors before continuing!')
        this.errorBar = true;
        return;
      }

      this.profileSaving = true;
      let data = {
        old_password: this.profilePass.password,
        new_password: this.profilePass.passwordNew
      };
      user.pass({}, data).then((r) => {
        this.profilePass.show = false;
      }, (e) => {
        let msg = extractBodyErrorMessages(e.body);
        if (!!msg)
          this.errorMsg = msg;
        else
          this.errorMsg = this.$t('Error changing profile password');
        this.errorBar = true;
      }).catch((err) => {
        this.errorMsg = this.$t('Unexpected error changing profile password');
        this.errorBar = true;
        console.log(err);
      }).finally(() => {
        this.profileSaving = false;
      });
    },
    poked(val) {
      this.poke = false;
    },
    onMenuItemClick(item) {
      if (item.id === 'wms' && !this.wms.enabled) {
        this.wms.modal = true;
      }
      else
      if (this.$route.path !== item.link) {
        this.$router.push(item.link);
      }
      this.poke = item.poke ? true : false;
    }
  },
  watch: {
    notifications: {
      handler() {
        this.notifications.unreadInitial = this.notifications.unread > 0
          ? this.notifications.unread
          : this.notifications.items;
      },
      deep: true
    }
  }
}
</script>
<style scoped>
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (max-width: 959px) {
  .main-nav-item.v-btn {
    min-width: 42px !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 960px) and (max-width: 1263px) {
  .main-nav-item.v-btn {
    min-width: 64px !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 1264px) {
  .main-nav-item.v-btn {
    min-width: 100px !important;
  }
}
@keyframes bell-shake-animation {
    2% { transform: rotateZ(15deg);  transform-origin: 50% 0%; }
    4% { transform: rotateZ(-15deg); transform-origin: 50% 0%; }
    6% { transform: rotateZ(20deg);  transform-origin: 50% 0%; }
    8% { transform: rotateZ(-20deg); transform-origin: 50% 0%; }
   10% { transform: rotateZ(15deg);  transform-origin: 50% 0%; }
   12% { transform: rotateZ(-15deg); transform-origin: 50% 0%; }
   14% { transform: rotateZ(10deg);  transform-origin: 50% 0%; }
   16% { transform: rotateZ(-10deg); transform-origin: 50% 0%; }
   18% { transform: rotateZ(8deg);   transform-origin: 50% 0%; }
   20% { transform: rotateZ(-8deg);  transform-origin: 50% 0%; }
   22% { transform: rotateZ(0);      transform-origin: 50% 0%; }
}

.bell-shake {
  animation: bell-shake-animation 5s ease infinite;
}
</style>

<style>
/* xs and sm */
@media only screen and (max-width: 959px) {
  .v-content[app] .v-toolbar > .v-toolbar__content {
    height: auto !important;
    min-height: 56px;
    flex-wrap: wrap;
    justify-content: end;
  }
  .v-content[app] .v-toolbar > .v-toolbar__content > .v-divider--vertical {
    margin-top:    8px;
    margin-bottom: 8px;
  }
  .v-content[app] .v-toolbar > .v-toolbar__content > .v-toolbar__title {
    padding-top:    4px;
    padding-bottom: 4px;
  }
  .v-content[app] .v-toolbar > .v-toolbar__content > .v-toolbar__items {
    height: auto;
  }
  .v-content[app] .v-toolbar > .v-toolbar__content > .v-toolbar__items > .v-divider--vertical {
    margin-top:    4px;
    margin-bottom: 4px;
  }
}
</style>
